import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	changeLayoutErrorFlagTitle: {
		id: 'dashboard-edit.utils.change-layout-error.change-layout-error-flag-title',
		defaultMessage: 'Error',
		description: 'The title for change layout error flag.',
	},
	changeLayoutErrorFlagDescription: {
		id: 'dashboard-edit.utils.change-layout-error.change-layout-error-flag-description',
		defaultMessage: 'Failed to save layout, please refresh the page',
		description: 'The description for change layout error flag.',
	},
	errorFlagAction: {
		defaultMessage: 'Refresh',
		id: 'dashboard-edit.utils.change-layout-error.error-flag-action',
		description: 'Label for button to reload the current page',
	},
});
